// v1.37.9: 全局 QueryClient 单例
//
// 抽出来是因为 auth-store.switchCompany 需要清空 react-query 缓存, 但
// queryClient 原本只在 main.tsx 里 new 出来 (模块内局部变量), 拿不到.
// main.tsx / auth-store 统一从这里 import, 保证是同一个实例。
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
